import React, { useState } from "react";
import Login from "./components/Login";
import Loading from "./components/Loading";
import { login, getCanvasAccount, isUserAdmin } from "../../services/api";
import {
  linkNewAccount,
  isSameSfmcAccount,
  isSameSfmcUser,
  updateLinkedAccount,
} from "./helpers";
import lodashGet from "lodash.get";
import LinkSuccess from "./components/LinkSuccess";
import AlreadyLinked from "./components/AlreadyLinked";
import ConfirmUpdate from "./components/ConfirmUpdate";
import {
  createInvalidJwtError,
  throwDifferentSfmcOrgError,
  throwNotCanvasAdminError,
  createError,
  ErrorTypes,
} from "../../services/errorFactory";
import DisplayError from "./components/DisplayError";

export default ({
  sfmcDetails,
  invalidJwt = false,
}: {
  sfmcDetails: any;
  invalidJwt?: boolean;
}) => {
  const [accessToken, setAccessToken] = useState();
  const [region, setRegion] = useState();
  const [canvasAccount, setCanvasAccount] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState(
    invalidJwt ? createInvalidJwtError() : undefined
  );
  const [loading, setLoading] = useState(false);

  const handleLogin = async (email, password, targetRegion) => {
    try {
      setLoading(true);
      const newAccessToken = await login(email, password, targetRegion);
      setAccessToken(newAccessToken);
      setRegion(targetRegion);
      const userIsAdmin = await isUserAdmin(newAccessToken, targetRegion);
      if (!userIsAdmin) {
        throwNotCanvasAdminError();
      }
      const account = await getCanvasAccount(newAccessToken, targetRegion);
      setCanvasAccount(account);
      if (!lodashGet(account, "integrations.sfmc")) {
        await linkNewAccount(
          account,
          sfmcDetails,
          newAccessToken,
          targetRegion
        );
        setShowSuccess(true);
      } else if (!isSameSfmcAccount(account, sfmcDetails)) {
        throwDifferentSfmcOrgError();
      } else if (isSameSfmcUser(account, sfmcDetails)) {
        await updateLinkedAccount(
          account,
          sfmcDetails,
          newAccessToken,
          targetRegion
        );
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      if (Object.values(ErrorTypes).includes(error.name)) {
        setError(error);
      } else {
        setError(createError());
      }
      setLoading(false);
    }
  };

  const handleBackNavigation = () => {
    setAccessToken(undefined);
    setRegion(undefined);
    setCanvasAccount(undefined);
    setError(invalidJwt ? createInvalidJwtError() : undefined);
    setLoading(false);
    setShowSuccess(false);
  };

  if (error && error.name !== ErrorTypes.LoginFailure) {
    return <DisplayError error={error} onClickBack={handleBackNavigation} />;
  }

  if (loading) {
    return <Loading />;
  }

  if (showSuccess) {
    return <LinkSuccess region={region} />;
  }

  if (isSameSfmcAccount(canvasAccount, sfmcDetails)) {
    if (isSameSfmcUser(canvasAccount, sfmcDetails)) {
      return <AlreadyLinked region={region} />;
    } else {
      return (
        <ConfirmUpdate
          region={region}
          sfmcDetails={sfmcDetails}
          canvasAccount={canvasAccount}
          accessToken={accessToken}
          setError={setError}
          setSuccess={setShowSuccess}
          onClickBack={handleBackNavigation}
        />
      );
    }
  }

  return (
    <Login
      handleLogin={handleLogin}
      loginErrorMessage={
        error && error.name === ErrorTypes.LoginFailure
          ? error.message
          : undefined
      }
    />
  );
};
